import { localStorageIsAuthenticatedKey, localStorageRefreshTokenKey, localStorageTokenKey } from '../entities/Authentication/Authentication';
import { authenticateWithSamlToken } from '../entities/Authentication/AuthenticationService';
import { FetchResultType } from '../entities/FetchResult';

export const getSamlLoginUrl = (): string | undefined => {
    let loginUrl = process.env.REACT_APP_SAML_LOGIN_URL;

    if (!loginUrl && process.env.REACT_APP_API_URL) {
        loginUrl = `${process.env.REACT_APP_API_URL.split('/api')[0]}/saml/login`;
        console.warn('REACT_APP_SAML_LOGIN_URL is not defined in the environment variables. Falling back to REACT_APP_API_URL, which is not recommended.');
    }

    const params = {
        source: 'manager-app',
        local: window.location.origin.includes('localhost') ? '1' : '0',
        tenant: process.env.REACT_APP_TENANT || window.location.hostname,
    };

    return `${loginUrl}?${new URLSearchParams(params).toString()}`;
};

export const navigateToSamlLogin = (): void => {
    const loginUrl = getSamlLoginUrl();
    if (!loginUrl) {
        console.error('SAML login URL is not defined. Please check your environment variables.');
        return;
    }

    window.location.href = loginUrl;
};

export const handleSamlLoginResponse = async (token: string): Promise<boolean> => {
    const response = await authenticateWithSamlToken(token);

    if (response.type === FetchResultType.Success && response.data?.refresh_token) {
        localStorage.setItem(localStorageIsAuthenticatedKey, 'true');
        localStorage.setItem(localStorageTokenKey, response.data.token ?? token);
        localStorage.setItem(localStorageRefreshTokenKey, response.data.refresh_token);

        return true;
    }

    return false;
};
